.organizationDetailsSection {
    display: flex;
    flex-direction: column;
    gap: var(--organization-details-section-gap);
    padding-bottom: var(--organization-details-section-padding-bottom);
    width: 100%;
}
